// extracted by mini-css-extract-plugin
export default {"container":"InfoBlock_container__OMd65","textBlock":"InfoBlock_textBlock__v7SfZ"};